module.exports = __webpack_public_path__ + "afcb40081e8072b796eb27aa5ddacb46.svg";